<template>
  <div>
    <b-col>
      <b-row class="my-4">
        <b-col lg="4">
          <p>جست و جو</p>
          <b-form-input
              @keypress.enter.prevent="search"
              v-model="searchWords"
              placeholder="جستجو"
          ></b-form-input>
        </b-col>
        <b-col lg="4">
          <p>وضعیت سفارش</p>
          <select @change="orderStatusFilter" v-model="orderStatusValue" class="custom-select">
            <option value="">همه موارد</option>
            <option v-for="(item,index) in loan_status" v-if="item!=''" :value="index">{{ item }}</option>
          </select>
        </b-col>
      </b-row>


    </b-col>

    <table-items :items="items" :restoreState="false"/>
    <div class="row pt-3">
      <div class="mt-3 color">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination";
import tableItems from "../../components/dashboard/Loan/tableItems.vue";
import {loan_status} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Loan'

export default {
  name: "LoansAdmin",
  components: {tableItems, Pagination},
  data() {
    return {
      searchWords: '',
      orderStatusValue: '',
      loan_status,
    }
  },
  computed: {
    ...mapGetters({
      items: "Loan/getLoans",
      paginationMeta: "Loan/getPaginationMeta",
    }),
  },
  methods: {
    changePage(page) {
      router.push({
        name: router.name,
        query: {...router.currentRoute.query, page: page},
      });
      this.$store.dispatch("Loan/getLoans", page);
    },
    search() {
      let page = 1
      this.$store.commit('Loan/setFilters', {key: 'search', value: this.searchWords})
      this.$store.dispatch("Loan/getLoans", page);
    },
    orderStatusFilter() {
      this.$store.commit("Loan/setFilters", {key: "status", value: this.orderStatusValue});
      this.$store.dispatch('Loan/getLoans', 1)
    }
  },
  async mounted() {
    await this.$store.dispatch("Loan/getLoans")
  },
};
</script>